/**
 * 보드 첨부파일 용량 상한 — 업로드 검증(`useFileUpload`)과 요금제 비교표가 같은
 * 값을 쓴다. 상한을 올릴 때 결제 화면만 옛 값으로 남는 드리프트를 막으려고
 * 페이지 밖으로 올렸다.
 */
export const MAX_FILE_SIZE_MB = 20;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
